import { EMPTY_ARRAY } from '~/core/util/array';
import { SolvReduxState } from '~/reducers';

const getInsurersState = (state: SolvReduxState) => state.insurers ?? null;

export const getInsurersList = (state: SolvReduxState) => getInsurersState(state) ?? EMPTY_ARRAY;
